import { Card, Row, Col } from 'react-bootstrap'
import Loading from '../../Loading/Loading'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { IValidationRequired } from '../../../validation/model'
import {
  useCreateSectionMutation,
  useGetSectionByIdQuery,
  useUpdateSectionMutation
} from '../../../store/api/expert/Section/section'
import { responseError, validationRequaired } from '../../../validation/validationRequaired'
import { toast } from 'react-toastify'
import { TCreateSectionPayload } from '../../../store/api/expert/Section/model'
import { ISelectData } from '../../../ui/Selects/select/model'
import SelectCourse from '../../../ui/Selects/SelectCourse/SelectedCourse'

const SectionCreate = (): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const { t: tRequired } = useTranslation('required')
  const navigate = useNavigate()
  const { id: sectionId } = useParams()
  const [createSection] = useCreateSectionMutation()
  const [updateSection] = useUpdateSectionMutation()
  const {
    isLoading,
    data: sectionDataById,
    refetch
  } = useGetSectionByIdQuery(Number(sectionId), { skip: !sectionId })

  const [errorRequired, setErrorRequired] = useState<IValidationRequired>({})
  const [selectedCourse, setSelectedCourse] = useState<ISelectData>()
  const [sendToBeck, setSendToBeck] = useState<TCreateSectionPayload>({} as TCreateSectionPayload)

  const onChange = (name: string, value: string | FileList): void => {
    if (name === 'files') {
      const fileArray = Array.from(value as FileList)
      setSendToBeck(prev => ({
        ...prev,
        [name]: fileArray,
        medias: fileArray.map(item => ({
          url: URL.createObjectURL(item)
        }))
      }))
      return
    }
    setSendToBeck(prev => ({ ...prev, [name]: value }))
  }

  const handleCreateUpdateSection = async (): Promise<void> => {
    const newObj: TCreateSectionPayload = {
      title: sendToBeck?.title,
      titleAr: sendToBeck?.titleAr,
      description: sendToBeck?.description,
      descriptionAr: sendToBeck?.descriptionAr,
      link: sendToBeck?.link,
      courseId: selectedCourse?.value
    }
    if ((sectionId && sendToBeck.files) || !sectionId) {
      newObj.files = sendToBeck.files
    }
    const errors = validationRequaired(newObj)

    setErrorRequired(errors)
    if (Object.keys(errors).length > 0) {
      return
    }
    const res = sectionId
      ? await updateSection({ id: Number(sectionId), ...newObj })
      : await createSection(newObj)

    if ('error' in res) {
      responseError(res)
    } else {
      toast.success('Section created successfully!')
      navigate(-1)
    }
  }

  useEffect(() => {
    if (sectionId) {
      refetch()
    }
  }, [sectionId])

  useEffect(() => {
    if (sectionDataById) {
      setSendToBeck({
        title: sectionDataById.title,
        titleAr: sectionDataById.titleAr,
        description: sectionDataById.description,
        descriptionAr: sectionDataById.descriptionAr,
        link: sectionDataById.link,
        courseId: sectionDataById.courseId,
        medias: sectionDataById.medias
      })
      if (sectionDataById?.course) {
        setSelectedCourse({
          label: sectionDataById?.course.title,
          value: sectionDataById?.course.id
        })
      }
    }
  }, [sectionDataById])

  return (
    <div>
      {sectionId && isLoading ? <Loading /> : null}
      <Card.Header>
        <h2>
          {tGeneral(sectionId ? 'edit' : 'create')} {tGeneral('section')}
        </h2>
      </Card.Header>
      <Row>
        <Col lg={12} xl={12} md={12} sm={12}>
          <Card>
            <Card.Body>
              <Row>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('title')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.title}
                    name='title'
                    className='form-control'
                    placeholder={tGeneral('title')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.title && (
                    <span className='text-danger'>{tRequired('title')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('titleAr')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.titleAr}
                    name='titleAr'
                    className='form-control'
                    dir='rtl'
                    placeholder={tGeneral('titleAr')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.titleAr && (
                    <span className='text-danger'>{tRequired('titleAr')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('description')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.description}
                    name='description'
                    className='form-control'
                    placeholder={tGeneral('description')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.description && (
                    <span className='text-danger'>{tRequired('description')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('descriptionAr')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.descriptionAr}
                    name='descriptionAr'
                    dir='rtl'
                    className='form-control'
                    placeholder={tGeneral('descriptionAr')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.descriptionAr && (
                    <span className='text-danger'>{tRequired('descriptionAr')}</span>
                  )}
                </Col>

                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('link')}
                  </label>
                  <input
                    type='url'
                    defaultValue={sendToBeck?.link}
                    name='link'
                    className='form-control'
                    placeholder={tGeneral('link')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.link && <span className='text-danger'>{tRequired('link')}</span>}
                </Col>
                <Col xs={6} md={7}>
                  <SelectCourse selected={selectedCourse} setSelected={setSelectedCourse} />
                  {errorRequired?.courseId && (
                    <span className='text-danger'>{tRequired('courseId')}</span>
                  )}
                </Col>
                <Col xs={6} md={7}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('file')}
                  </label>
                  <input
                    type='file'
                    name='files'
                    multiple
                    maxLength={5}
                    className='form-control'
                    accept='image/*'
                    onChange={({ target }) => onChange(target.name, target.files)}
                  />
                  {errorRequired?.image && (
                    <span className='text-danger'>{tRequired('image')}</span>
                  )}
                  {sendToBeck?.medias?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className='avatar avatar-lg brround cover-image bg-primary mr-10'
                      >
                        <img
                          width={200}
                          height={200}
                          src={item.url}
                          className='avatar avatar-lg brround cover-image bg-primary object-fit-contain'
                          alt=''
                        />
                      </div>
                    )
                  })}
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className='text-end'>
              <button
                className='btn btn-success mt-1 me-2'
                onClick={() => handleCreateUpdateSection()}
              >
                {tGeneral('save')}
              </button>
              <button
                type='button'
                className='btn btn-danger mt-1 me-2'
                onClick={() => navigate(-1)}
              >
                {tGeneral('cancel')}
              </button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default SectionCreate
